<mat-spinner *ngIf="loading"></mat-spinner>
<div *ngIf="!loading" class="edit-actions">
    <mat-spinner *ngIf="loadingAction" [diameter]="20"></mat-spinner>
    <button *ngIf="!loadingAction" matTooltip="Cancelar" (click)="cancel()" mat-icon-button class="card-inline">
    <mat-icon>clear</mat-icon>
    </button>
    <button *ngIf="!loadingAction && !readOnly" matTooltip="Guardar" (click)="finish()" mat-icon-button class="card-inline">
      <mat-icon>done</mat-icon>
    </button>
</div>
<mat-tab-group *ngIf="!loading" (selectedIndexChange)="selectedIndexChange($event)" #tabGroup>
    <mat-tab label="Paciente">
        <div class="card-base  margin-botton-medium">
            <div class="card-content-wizard">
                <div class="card-container mat-elevation-z1">
                    <app-admission-patient-component [hidden]="loading" #admissionPatientComponent></app-admission-patient-component>
                </div>
            </div>
        </div>
    </mat-tab>
    <mat-tab label="Valorización">
        <div class="card-base  margin-botton-medium">
            <div class="card-content-wizard">
                <div class="card-container mat-elevation-z1">
                    <app-admission-valorization-component [hidden]="loading" #admissionValorizacionComponent></app-admission-valorization-component>
                </div>
            </div>
        </div>
    </mat-tab>
    <mat-tab label="Orden">
        <div class="card-base  margin-botton-medium">
            <div class="card-content-wizard">
                <div class="card-container mat-elevation-z1">
                    <app-admission-medical-order-component [hidden]="loading" #admissionMedicalOrderComponent></app-admission-medical-order-component>
                </div>
            </div>
        </div>
    </mat-tab>
    <mat-tab label="Escaneos">
        <div class="card-base  margin-botton-medium">
            <div class="card-content-scan">
                <div class="card-container mat-elevation-z1">
                    <div class="card-content">
                        <medical-order-scann-control [hidden]="loading" [medicalorderId]="medicalorderId"></medical-order-scann-control>
                    </div>
                </div>
            </div>
        </div>
    </mat-tab>
    <mat-tab label="Operaciones">
        <div class="margin-botton-medium">
            <app-admission-operation-component [hidden]="loading" #admissionOperationComponent></app-admission-operation-component>
        </div>
    </mat-tab>
</mat-tab-group>